import { trans } from "@/service/i18n/i18n";

export function makeLabel(field: Field, customLabel = null) {
  const label = customLabel ?? trans(field.label);
  return (
    label + (field.required ? " <span class='error text-red-500'>*</span>" : "")
  );
}

export function normalizeFields<T extends Record<string, Field>>(fields: T): T {
  Object.keys(fields).forEach((name) => {
    const field = fields[name];
    field.name = name;
    field.error = field.error ?? null;
    if (["text", "textarea"].includes(field.type as string)) {
      field.value = field.value ?? "";
    }
  });

  return fields;
}

export function normalizeFilters<
  T extends Record<string, Omit<Filter, "name">>,
>(filters: T): { [K in keyof T]: Filter } {
  const normalizedFilters = {} as { [K in keyof T]: Filter };
  Object.keys(filters).forEach((name) => {
    normalizedFilters[name as keyof T] = {
      ...filters[name],
      name,
    };
  });

  return normalizedFilters;
}

export async function getCaptcha(
  action: string,
  NEXT_PUBLIC_RECAPTCHA_SITE_KEY: string,
) {
  // @ts-expect-error ts cant' find grecaptcha
  if (!grecaptcha) {
    return "";
  }

  return await grecaptcha.execute(NEXT_PUBLIC_RECAPTCHA_SITE_KEY, {
    action,
  });
}
